import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import ImModuleStyle from '../styles/im.module.css';
require('highcharts/modules/accessibility')(Highcharts);

const InventoryGraph = ({ type = "monthly", simObj }) => {
  const [leftPosition, setLeftPosition] = useState(type == "monthly" ? 83 : type == "quarterly" ? 82 : 76);
  const bounds = { left: 0, right: 556 };
  const [xAxisLabelArray, setxAxisLabelArray] = useState([]);
  const [stepCount, setStepCount] = useState(0);
  const [monthlydata, setMonthlyData] = useState('');
  const [chart, setChart] = useState(null);
  let graphSettings = {};
  const getDate = (date) => {
  let formattedDate;
  let dateObject = new Date(date);
  let options = { year: 'numeric', month: 'long', day: 'numeric' };
  if(navigator.userAgent.indexOf('iPhone') > -1){
     dateObject = new Date(date.replace(/-/g, "/"));
  }
 return dateObject.toLocaleDateString(navigator.language, options);
}
  function getMonthDays(year, month) {
    // Months are 0-based in JavaScript (0 - January, 1 - February, ..., 11 - December)
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
  }
  // const setGraphSettings = () => {
  //    graphSettings = {
  //     chart: {
  //       type: "column",
  //       marginTop: 50,
  //       plotBorderWidth: 2,
  //       //panning: type === "quarterly",
  //     },
  //     // title: {
  //     //   text: "<span x=230 style='font-size:14px; font-weight:bold;'>Units left: 382</span> <span x=420 style='font-size:14px; font-weight:bold;'>Demand: 37</span>",
  //     //   verticalAlign: 'top',
  //     //   align: 'center',

  //     // },
  //     title: {
  //       text: null
  //     },
  //     legend: {
  //       align: "left",
  //       verticalAlign: "top",
  //       floating: true,
  //       visible: true,
  //       y: -10,
  //       itemStyle: {
  //         fontWeight: 'bold',
  //         fontSize: '14px'
  //       }
  //     },

  //     xAxis: xAxis[type],
  //     yAxis: yAxis[type],
  //     credits: {
  //       enabled: false
  //     },
  //     series: [
  //       {
  //         name: "Inventory",
  //         pointWidth: type === "monthly" ? 16 : 6,
  //         borderRadius: 0,
  //         data: InventoryData[type],
  //         color: "#579E96",
  //       }
  //     ],
  //     tooltip: {
  //       shared: false,
  //       useHTML: true, // Enable HTML content in tooltip
  //       headerFormat: '',
  //       hideDelay: 0,
  //       formatter: formatterFunIG(type),
  //       style: {
  //         color: '#fff'
  //       },
  //       valueDecimals: 0,
  //       backgroundColor: '#000',
  //       borderColor: '#000',
  //       borderRadius: 0,
  //       borderWidth: 3,
  //     }
  //   }
  // }

  const setGraphData = () => {
    if (chart) {
      let inventoryMonthlyData = [];
      let inventoryQuarterlyData = [];
      let inventoryYearlyData = [];
      let newPoint = "";
      let existingData = "";
      let newData = "";
      chart?.yAxis[0]?.update({ min: 0, max: undefined });
      let monthDays = 0;
      switch (type) {
        case "monthly":
          inventoryMonthlyData = simObj?.graphdata?.filter((data, index) => {
            if (data?.sm === simObj?.laststate?.statemonth) {
              return true;
            }
          });
          inventoryMonthlyData = (inventoryMonthlyData != undefined ? inventoryMonthlyData : []).map((data) => {
            return {
              x: data.sd,
              y: data.ul ? data.ul : 500,
              date: getDate(data.cd),
              demandCost: data.dd,
              unitsLeft: data.ul,
              color: data.ul <= 0 ? "#db0020" : "#467E78"
            }
          });
          newPoint = inventoryMonthlyData[inventoryMonthlyData.length - 1]
          InventoryData["monthly"] = inventoryMonthlyData;
          if (InventoryData["monthly"].length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(InventoryData["monthly"]);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series[0]?.options?.data;
            newData = [...existingData, newPoint];
            // Update the series data with the new data
            chart?.series[0]?.setData(newData);
          }

          // debugger;
          // // Calculate min and max values based on units left data
          // const minUnitsLeft = 0;
          // const maxUnitsLeft = Math.max(...inventoryMonthlyData.map(data => data.unitsLeft));

          // // Calculate tick interval in multiples of hundreds or thousands
          // const valueRange = Math.ceil(maxUnitsLeft - minUnitsLeft);
          // let tickInterval = 1;

          // if (valueRange > 10000) {
          //   valueRange = 20000;
          //   tickInterval = (valueRange / 4 / 5000) * 10000; // Multiples of thousands
          // } else
          // if (valueRange > 1000) {
          //   tickInterval = (valueRange / 4 / 1000) * 1000; // Multiples of thousands
          // } else if (valueRange > 100) {
          //   tickInterval = (valueRange / 4 / 100) * 100; // Multiples of hundreds
          // } else {
          //   tickInterval = (valueRange / 4); // Default tick interval
          // }

          // // Calculate the rounded max value, rounding to next 10000 if valueRange > 10000
          // const roundedMax = valueRange > 10000 ? Math.ceil(maxUnitsLeft / 10000) * 10000 : Math.ceil(maxUnitsLeft / tickInterval) * tickInterval;

          // // Update yAxis configuration in graphSettings
          // graphSettings.yAxis[type] = {
          //   min: Math.floor(minUnitsLeft / tickInterval) * tickInterval,
          //   max: roundedMax,
          //   title: {
          //     text: "Units",
          //     style: {
          //       fontWeight: '500',
          //       fontSize: '14px',
          //       color: "#000"
          //     },
          //   },
          //   tickInterval: tickInterval,
          //   gridLineWidth: 0,
          //   labels: {
          //     formatter: function () {
          //       return Highcharts.numberFormat(this.value, 0);
          //     },
          //   }
          // };

          // // Update chart yAxis
          // chart.yAxis[0].update(graphSettings.yAxis[type]);          
          (simObj?.laststate?.stateyear != undefined && simObj?.laststate?.statemonth != undefined) && chart?.xAxis[0]?.update({ min: 1, max:  getMonthDays(simObj?.laststate?.stateyear, simObj?.laststate?.statemonth)});

          (inventoryMonthlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        case "quarterly":
          inventoryQuarterlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.sm >= simObj?.laststate?.statemonth - 2) {
              return true;
            }
          });
          inventoryQuarterlyData = (inventoryQuarterlyData != undefined ? inventoryQuarterlyData : []).map((data) => {
            return {
              x: (data.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data.sm)),
              y: data.ul ? data.ul : 500,
              demandCost: data.dd,
              unitsLeft: data.ul,
              date: getDate(data.cd),
              color: data.ul <= 0 ? "#db0020" : "#467E78"
            }
          });
          InventoryData["quarterly"] = inventoryQuarterlyData;
          // xAxis.quarterly.min = simObj.laststate.statemonth - 3;
          // xAxis.quarterly.max = simObj.laststate.statemonth;

          if (InventoryData["quarterly"].length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(InventoryData["quarterly"]);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series[0]?.options?.data;
            newData = [...existingData, inventoryQuarterlyData[inventoryQuarterlyData.length - 1]];

            // Update the series data with the new data
            chart?.series[0]?.setData(newData);
          }

          let min = 0, max = 0;
          if (simObj?.laststate?.statemonth / 3 >= 0 && simObj?.laststate?.statemonth / 3 <= 1) {
            min = 0;
            max = 3;
          }
          else if (simObj?.laststate?.statemonth / 3 > 1 && simObj?.laststate?.statemonth / 3 <= 2) {
            min = 3;
            max = 6;
          }
          else if (simObj?.laststate?.statemonth / 3 > 2 && simObj?.laststate?.statemonth / 3 <= 3) {
            min = 6;
            max = 9;
          }
          else if (simObj?.laststate?.statemonth / 3 > 3 && simObj?.laststate?.statemonth / 3 <= 4) {
            min = 9;
            max = 12;
          }
          chart?.xAxis[0]?.update({
            // min: simObj.laststate.statemonth-1,
            // max: simObj.laststate.statemonth+2
            min: min,
            max: max
          });
          (inventoryQuarterlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        case "yearly":
          inventoryYearlyData = simObj?.graphdata;

          inventoryYearlyData = (inventoryYearlyData != undefined ? inventoryYearlyData : []).map((data) => {
            return {
              x: (data?.sm - 1) + (data.sd / getMonthDays(simObj?.laststate?.stateyear, data?.sm)),
              y: data.ul ? data.ul : 500,
              demandCost: data.dd,
              unitsLeft: data.ul,
              date: getDate(data.cd),
              color: data.ul <= 0 ? "#db0020" : "#467E78"
            }
          });
          InventoryData["yearly"] = inventoryYearlyData;

          if (inventoryYearlyData.length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(inventoryYearlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series[0]?.options?.data;
            newData = [...existingData, inventoryYearlyData[inventoryYearlyData.length - 1]];

            // Update the series data with the new data
            chart?.series[0]?.setData(newData);
          }
          (inventoryYearlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        default:
          break;
      }
    }
  }
  const resetDrag = () => {
    setLeftPosition(type == "monthly" ? 83 : type == "quarterly" ? 82 : 76)
  }
  const handleDrag = (e, draggableData) => {
    //setLeftPosition(leftPosition + draggableData.x);
  };

  function applyAccessibility(chart) {
      if (chart && chart.renderTo) {
      const svg = chart.renderTo.querySelector("svg.highcharts-root");
      if (svg) {
        setTimeout(() => {
          svg.setAttribute("role", "img");
          svg.setAttribute(
          "aria-label",
          "Bar chart showing daily inventory levels for the current month in units. Each bar represents the available inventory for that day."
          );

          const oldDesc = svg.querySelector("desc");
          if (oldDesc) oldDesc.remove();

          const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
          desc.textContent =
          "This bar chart displays inventory levels for each day of the current month. The x-axis represents the days of the month from 1 to 30, while the y-axis shows units of inventory.";
          svg.insertBefore(desc, svg.firstChild);
        },0);
      }
      }
  }

  const formatterFunIG = (type) => {

    switch (type) {
      case "monthly":
        return function () {
          return `
            <div className=${`${ImModuleStyle.tooltip}`}>
              <div>Day:${this.point.date}</div>
              <div>Units left: ${this.point.unitsLeft} </div>
              ${this.point.demandCost ? `<div>Demand: ${this.point.demandCost}</div>` : ``}              
            </div>
          `;
        };
      case "quarterly":
        return function () {
          return `
            <div className=${`${ImModuleStyle.tooltip}`}>
              <div>Day: ${this.point.date}</div>
              <div>Units left: ${this.point.unitsLeft} </div>
              ${this.point.demandCost ? `<div>Demand: ${this.point.demandCost}</div>` : ``}              
            </div>
          `;
        };
      case "yearly":
        return function () {
          return `
            <div className=${`${ImModuleStyle.tooltip}`}>
              <div>Day: ${this.point.date}</div>
              <div>Units left: ${this.point.unitsLeft} </div>
              ${this.point.demandCost ? `<div>Demand: ${this.point.demandCost}</div>` : ``}              
            </div>
          `;
        };
      default:
        return null;
    }

  }
  const InventoryData = {
    "monthly": [],
    "yearly": [],
    "quarterly": []
  }
  const xAxis = {
    "monthly": {
      min: 1,
      max: 31,
      step: 1,
      gridLineWidth: 1.5,
      tickInterval: 1,
      tickLength: 0,
      lineColor: '#C6C6C3',
      title: {
        text: "Day of Month",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        },
      },
      labels: {
        rotation: 0
      }
    },
    "quarterly": {
      // categories: ["",'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      // tickPositions: [9, 10, 11], // Assuming October starts at index 9 in the data array
      gridLineWidth: 1,
      tickInterval: 1,
      tickLength: 0,
      min: 0,
      max: 3,
      labels: {
        formatter: function () {
          const months = ["", 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
          return months[this.value];
        },
        style: {
          fontSize: '0.8em',
          color: "#000"
        }
      },
      lineColor: '#C6C6C3',
      title: {
        text: "Month",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      rangeSelector: {
        selected: 1
      }
    },
    "yearly": {
      min: 0,
      max: 12, // Use max value as 3 for four quarters (Q1, Q2, Q3, Q4)
      gridLineWidth: 1,
      tickInterval: 3,
      tickLength: 0,
      tickmarkPlacement: 'on',
      lineColor: '#C6C6C3',
      title: {
        text: "Quarter",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      labels: {
        formatter: function () {
          const quarters = ['', '', '', 'Q1', '', '', 'Q2', '', '', 'Q3', '', '', 'Q4'];
          return quarters[this.value];
        },
      },
    }
  }
  const yAxis = {
    "monthly": {
      // min: 0,
      // max: 800,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 6,
      title: {
        text: "Units",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        },
      },
      // tickInterval: 200,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0);
        },
      }
    },
    "quarterly": {
      //min: 0,
      // max: 800,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 6,
      title: {
        text: "Units",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        },
      },
      // tickInterval: 200,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0);
        },
      }
    },
    "yearly": {
      //min: 0,
      // max: 800,
      maxPadding: 0.1,
      tickInterval: null,
      tickAmount: 6,
      color: 'rgb(255,255,255)',
      title: {
        text: "Units",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      // tickInterval: 200,
      gridLineWidth: 0,
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0);
        }
      },
    }
  }
  graphSettings = {
    chart: {
      type: "column",
      responsive: false,
      marginRight: 14,
      // marginTop: 50,
      marginTop: 8,
      height:200,
      plotBorderWidth: 1,
      //panning: type === "quarterly",
      events: {
        render: function () {
            applyAccessibility(this);
        },
        redraw: function () {
            applyAccessibility(this);
        }
      }
    },
    // title: {
    //   text: "<span x=230 style='font-size:14px; font-weight:bold;'>Units left: 382</span> <span x=420 style='font-size:14px; font-weight:bold;'>Demand: 37</span>",
    //   verticalAlign: 'top',
    //   align: 'center',

    // },
    title: {
      text: null
    },
    legend: {
      enabled:false,
      align: "left",
      verticalAlign: "top",
      floating: true,
      visible: true,
      y: -10,
      itemStyle: {
        fontWeight: 'bold',
        fontSize: '14px'
      }
    },

    xAxis: xAxis[type],
    yAxis: yAxis[type],
    accessibility: {
      enabled: true,
      description: '',
      pointDescriptionFormatter: function (point) {
        // Customize the aria-label for each point
        return `Day: ${point.date}; Units left: ${point.unitsLeft}; ${point.demandCost ? `<div>Demand: ${point.demandCost}</div>` : ``}
        `;
      },
      keyboardNavigation: {
        enabled: true, // Enable keyboard navigation
      },
      screenReaderSection: {
        beforeChartFormat: '' // disables their auto "Interactive chart" label
      }  
    },
    credits: {
      enabled: false
    },
    series: [
      {
        name: "Inventory",
        pointWidth: type === "monthly" ? 16 : type === "quarterly" ? 6 : type === "yearly" ? 0.5 : 0,
        borderWidth:  1,
        borderRadius: 0,
        crisp: type === "quarterly" ? false : type === "yearly" ? false : true,
        states: {
          hover: {
              borderWidth: 1, // Border width on hover
              borderColor: 'black' // Border color on hover
          }
      },
        data: [],
        color: "#467E78",
      }
    ],
    tooltip: {
      shared: false,
      useHTML: true, // Enable HTML content in tooltip
      headerFormat: '',
      hideDelay: 0,
      formatter: formatterFunIG(type),
      style: {
        color: '#fff'
      },
      valueDecimals: 0,
      backgroundColor: '#000',
      borderColor: '#000',
      borderRadius: 0,
      borderWidth: 3,
    }
  }
  const updateXAxisLabelArray = () => {
    var xAxisLabelArr = [];
    // for (var i = 0; i <= InventoryData[type].length; i++) {
    //   xAxisLabelArr.push(InventoryData[type][i].x);
    // }
    xAxisLabelArr = InventoryData[type].map((data => {
      return data.x;
    }))
    // console.log(xAxisLabelArr);
    setxAxisLabelArray(xAxisLabelArr);
  }
  // const initGraph = () => {
  //   Highcharts.chart("InventoryGraph", graphSettings);
  // }
  const handleKeyDown = (e) => {
    const { key } = e;
    var min = (type == "monthly" ? 83 : type == "quarterly" ? 82 : 76);

    const max = Math.round(window.$("#InventoryGraph").width()) - 10;
    // const maxPosition = 578;
    const maxPosition = window.$("#InventoryGraph .highcharts-plot-background").width();
    const maxMonthDay = 31; // The maximum month index (assuming the x-axis labels represent months from 1 to 12)
    const step = type == "monthly" ? (maxPosition / maxMonthDay) : type == "quarterly" ? (maxPosition / 92) : type == "yearly" ? (maxPosition / 365) : 1;

    switch (key) {
      case 'ArrowLeft':
        setLeftPosition((prevLeft) => Math.max(prevLeft - step, min));
        setStepCount((stepCount) ? stepCount - 1 : 0);
        break;
      case 'ArrowRight':
        setLeftPosition((prevLeft) => (prevLeft + step) > max ? prevLeft : (prevLeft + step));
        setStepCount((stepCount < xAxisLabelArray.length) ? stepCount + 1 : xAxisLabelArray.length);
        break;
      case 'ArrowUp':
        setLeftPosition((prevLeft) => Math.max(prevLeft - step, min));
        setStepCount((stepCount < xAxisLabelArray.length) ? stepCount + 1 : xAxisLabelArray.length);
        break;
      case 'ArrowDown':
        setLeftPosition((prevLeft) => (prevLeft + step) > max ? prevLeft : (prevLeft + step));
        setStepCount((stepCount) ? stepCount - 1 : 0);
        break;

      default:
        break;
    }
  };

  const graphAccessibility = () => {
    let currReveArr = InventoryData[type].filter((data) => data?.x == xAxisLabelArray[stepCount]);

    let revenueHeading = "";
    let revenueTooltipTxt = "";
    currReveArr?.map((currReveObj) => {
      revenueHeading = `Inventory Tooltip <br/>`
      revenueTooltipTxt = type == "monthly" ? `Day: December ${currReveObj.x} <br/> Units-left: $${currReveObj.unitsLeft} <br/> Demand Cost: $${currReveObj.demandCost} <br/>` : `Day: ${currReveObj.date} <br/> Units-left: $${currReveObj.unitsLeft} <br/> Demand Cost: $${currReveObj.demandCost} <br/>`;
    });

    const monthlydata = revenueHeading + revenueTooltipTxt
    setMonthlyData(monthlydata);
  };
  useEffect(() => {
    graphAccessibility();
  }, [stepCount]);
  useEffect(() => {
    // setGraphData();
    // setGraphSettings();
    updateXAxisLabelArray();
    graphAccessibility();
    resetDrag();
  }, [type, simObj]);

  useEffect(() => {
    // Initialize the 
    const newChart = Highcharts.chart("InventoryGraph", graphSettings);
    setChart(newChart);
  }, [type]);

  useEffect(() => {
    setGraphData();
    if (chart) {
      document.querySelector("#InventoryGraph .highcharts-container ").setAttribute('tabindex', '0');
    }
  }, [chart, simObj?.laststate, simObj?.currentstep]);

  return (
    <div className={`${ImModuleStyle['graph-container']}`}>
      {/* <Draggable axis="x" onDrag={handleDrag} bounds={bounds} >

        <div id="RevenueGraphArrow" style={{ 'left': leftPosition }} >
          <div className="slider-dragger" aria-label="Slider Position Month -1" tabIndex={0} role="slider" aria-valuemin={0} aria-valuemax={556} aria-valuenow={xAxisLabelArray[stepCount]} onKeyDown={handleKeyDown}>
            <div className="slider-text" aria-hidden="true">V</div>
          </div>
        </div>
      </Draggable> */}
      {!simObj?.graphdata?.length && <div className={`${ImModuleStyle['nodata-alert-inventory']}`}>Inventories will appear here as the simulation runs</div>}
      <a href="#" onClick={(e)=> e.preventDefault()} aria-label="Legend: Column for Inventory" className="sr-only"></a>
      <div id="InventoryGraph" className={`${ImModuleStyle['inventory-graph']}`}></div>
    </div>
  )
}

export default InventoryGraph